export const url = {
  listupload: '/auth/concept/list', // upload
  segment: '/auth/public/segment_list',
  withdraw: '/auth/concept/withdraw',
  uploadfile: '/auth/public/upload_file',
  FILES_LIST: '/auth/public/fileList', // 下拉出最多30个文件
  draft: '/auth/concept/saveOrSubmitConcepts', // 保存草稿
  RELATE_FILE_IMAGE: '/auth/public/relateFileImage',
  FORMULATION_ID: '/auth/formulation/getFormulations', // 获取formulationIds
  DETAIL: '/auth/concept/detail',
  TRADENAME_ID: '/auth/trade/getBasfProductsByPrd', // 获取basfProduct的prd
  CLAIM: '/auth/public/get_goodsClaim', // 模糊查找claim
  list: '/manage/concept/list', // management
  EXPORT_LIST: '/manage/concept/export', // 导出
  detail: '/manage/concept/detail', // 编辑详情
  approval: '/manage/concept/approval', // upload模块 pengding-approve withdraw
  managementpreview: '/manage/concept/detail', // 管理模块 pending-approval 预览
  searchApproveUserList: '/auth/user/searchApproveUserList',
  saveOrSubmitConcepts: '/auth/concept/saveOrSubmitConcepts',
  uploadConceptCount: '/auth/concept/conceptCount',
  managementConceptCount: '/manage/concept/conceptCount',
  managementEdit: '/manage/concept/submitConceptByAdmin', // admin-修改后提交
  searchUserList: '/auth/user/searchUserList',
  getLastApprovalDate: '/manage/concept/getLastApprovalDate', // 获取最后更新时间
  handleEnable: '/manage/concept/enableOperate',
  setNewConcept: '/manage/concept/setNewConcept',
  getTrend: '/auth/trend/getRelatedTrend',
  getMediaList: '/auth/media/search/list',
  getUploadConceptCount: '/auth/concept/myConceptCount',
  deleteDraft: '/auth/concept/delete',
  setKeyProduct: '/manage/concept/key/set'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/concept.js